import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import ErrorMessage from "../components/ErrorMessage";
import apiService from "../services/api";

import "../styles/global.css";
import "../styles/categoryitemspage.css";

export default function CategoryItemsPage() {

  const { category } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState(""); // "low" or "high"
  const [foodType, setFoodType] = useState(""); // "veg" | "nonveg" | ""


const restaurantId =
  location.state?.restaurantId;


  useEffect(() => {

  window.scrollTo(0, 0);

}, []);

  const [restaurant, setRestaurant] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState(null);

useEffect(() => {

  const restaurantId =
    location.state?.restaurantId;

  if (!restaurantId) return;

  const fetchRestaurant = async () => {

    try {

      setLoading(true);

      const response =
        await apiService.getRestaurantDetails(
          restaurantId
        );

      setRestaurant(response);

    } catch (err) {

      console.error(err);

      setError(
        "Failed to load category items"
      );

    } finally {

      setLoading(false);

    }

  };

  fetchRestaurant();

}, [location.state]);


  const handleItemClick =
    (item) => {

      navigate(
        `/item/${item.itemId}`,
        {
          state: {
            item,
            restaurantId,
          },
        }
      );

    };

  if (loading) return <Loader />;

  if (error)
    return (
      <ErrorMessage message={error} />
    );
let categoryItems = restaurant.items.filter((item) => {
  const matchesCategory = item.category === category;

  const matchesSearch = item.name
    .toLowerCase()
    .includes(search.toLowerCase());

  const matchesType =
    foodType === ""
      ? true
      : foodType === "veg"
      ? item.type?.toLowerCase() === "veg"
      : item.type?.toLowerCase() === "non-veg";

  return matchesCategory && matchesSearch && matchesType;
});

// 🔥 PRICE SORTING (IMPORTANT)
if (sortOrder === "low") {
  categoryItems = [...categoryItems].sort((a, b) => a.price - b.price);
} else if (sortOrder === "high") {
  categoryItems = [...categoryItems].sort((a, b) => b.price - a.price);
}

// 🔍 Similar suggestions (based on name letters)
const suggestedItems = restaurant.items
  .filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase().slice(0, 3))
  )
  .slice(0, 6); // limit suggestions


  return (

    <div className="menu-container" style={{padding:"20px"}}>

      <div style={{display:"flex",alignItems:"center"}}>

    <button
      className="icon-btn"
      onClick={() => navigate(-1)}
    >
      ←
    </button>
    <div className="top-bar" style={{alignSelf:"center",display:"flex",justifyContent:"center",width:"100%"}}>


        <h3 style={{margin:"0px"}} className="topname">
          {category}
        </h3>


      </div>
      </div>

      <div className="filter-bar">

  <input
    type="text"
    placeholder="Search food..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    className="search-input"
  />

<select
  value={sortOrder}
  onChange={(e) => setSortOrder(e.target.value)}
  className="sort-select"
>
  <option value="">Price</option>
  <option value="low">↑ Low</option>
  <option value="high">↓ High</option>
</select>
  <select
  value={foodType}
  onChange={(e) => setFoodType(e.target.value)}
  className="sort-select"
>
  <option value="">All</option>
  <option value="veg">Veg</option>
  <option value="nonveg">Non-Veg</option>
</select>

</div>

<div className="grid-container">

  {categoryItems.length > 0 ? (

    categoryItems.map((item) => (
      <div
        key={item.itemId}
        className="food-card1"
        onClick={() => handleItemClick(item)}
      >
        <img src={item.imageUrl} alt={item.name} />
        <div className="food-info">
          <h4>{item.name}</h4>
          <span className="price">₹{item.price}</span>
        </div>
      </div>
    ))

  ) : (

    <div style={{ width: "200%", textAlign: "center", marginTop: "30px" }}>

      <h3>No items found 😕</h3>

      {search && (
        <>
          <p>Try searching something else</p>

          <h4 style={{ marginTop: "20px" }}>You may like 👇</h4>

          <div className="grid-container">

            {suggestedItems.map((item) => (
              <div
                key={item.itemId}
                className="food-card1"
                onClick={() => handleItemClick(item)}
              >
                <img src={item.imageUrl} alt={item.name} />
                <div className="food-info">
                  <h4>{item.name}</h4>
                  <span className="price">₹{item.price}</span>
                </div>
              </div>
            ))}

          </div>
        </>
      )}

    </div>

  )}

</div>
    </div>

  );

}